import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Tabs, Tab } from '@mui/material';
import { Business as BusinessIcon, IntegrationInstructions as IntegrationIcon } from '@mui/icons-material';
import API from '@utils/axios';
import PackTypeIcon from '@components/pack/PackTypeIcon';
import TabIconBadge from '@components/TabIconBadge';

const CustomerTabs = ({ customer, currentTab }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [integrations, setIntegrations] = useState([]);
    const [integrationsLoaded, setIntegrationsLoaded] = useState(false);

    useEffect(() => {
        if (customer && customer.id) {
            API.get(`/customers/${customer.id}/services-urls`)
                .then(response => setIntegrations(response.data))
                .catch(error => console.error('Error fetching integrations:', error))
                .finally(() => setIntegrationsLoaded(true));
        }
    }, [customer]);

    return (
        <Tabs value={currentTab}>
            <Tab 
                value="infos" 
                label={t("Information")} 
                onClick={() => navigate(`/customers/${customer?.id}`)} 
                icon={<BusinessIcon />}
            />
            <Tab 
                value="integrations"
                label={t("Integrations")}
                onClick={() => navigate(`/customers/${customer.id}/integrations`)}
                icon={<TabIconBadge value={integrationsLoaded ? integrations?.length || 0 : null} icon={<IntegrationIcon />} />}
            />
            <Tab 
                value="sms" 
                label={t("{{type}} credits", { type: t("credit.sms") })} 
                onClick={() => navigate(`/customers/${customer.id}/packs/sms`)} 
                icon={<TabIconBadge value={customer?.credits?.sms || null} icon={<PackTypeIcon type="sms" />} />}
            />
            <Tab 
                value="email" 
                label={t("{{type}} credits", { type: t("credit.email") })} 
                onClick={() => navigate(`/customers/${customer.id}/packs/email`)} 
                icon={<TabIconBadge value={customer?.credits?.email || null} icon={<PackTypeIcon type="email" />} />}
            />
        </Tabs>
    );
};

export default CustomerTabs;